import { Colors } from '@gripp/shared-ui';
import { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Menu, Modal, Portal } from 'react-native-paper';
import { AddButton } from '../../shared/components/addButton/addButton';
import { CreateFileForm } from './createFileForm';

type MediaType = 'file' | 'link';

/**
 * Header variant of the create-file dropdown. Uses the Crop Circle orange
 * `AddButton` as the Menu anchor (rendered in `FilesFilters` alongside the
 * search/filter icons). Keeps the same File / Link two-step dropdown as
 * `CreateFileDropdown`, which remains in use on the legacy path.
 */
export const CreateFileHeaderButton = () => {
  const [visible, setVisible] = useState(false);
  const [selectedType, setSelectedType] = useState<MediaType | null>(null);

  const openMenu = () => setVisible(true);
  const closeMenu = () => setVisible(false);

  const handleTypeSelect = (type: MediaType) => {
    setSelectedType(type);
    closeMenu();
  };

  const handleModalComplete = () => {
    setSelectedType(null);
  };

  return (
    <View style={styles.container}>
      <Menu
        visible={visible}
        onDismiss={closeMenu}
        contentStyle={styles.menuContent}
        anchor={<AddButton onPress={openMenu} />}
      >
        <Menu.Item
          leadingIcon="file-upload"
          onPress={() => handleTypeSelect('file')}
          title="File"
          style={styles.menuItem}
        />
        <Menu.Item
          leadingIcon="link"
          onPress={() => handleTypeSelect('link')}
          title="Link"
          style={styles.menuItem}
        />
      </Menu>

      <Portal>
        <Modal
          visible={!!selectedType}
          onDismiss={handleModalComplete}
          contentContainerStyle={styles.modalContainer}
        >
          {selectedType && (
            <CreateFileForm
              type={selectedType}
              onComplete={handleModalComplete}
            />
          )}
        </Modal>
      </Portal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
  },
  menuContent: {
    backgroundColor: Colors.role.surface,
    flexDirection: 'column',
    flex: 1,
    top: 40,
  },
  menuItem: {
    backgroundColor: Colors.role.surface,
  },
  modalContainer: {
    alignSelf: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 560,
    borderRadius: 12,
    backgroundColor: Colors.role.surfaceHover,
  },
});
